export default __webpack_public_path__ + "static/media/nbiot_green_rgb.b1376150.png";